module.exports = __webpack_public_path__ + "img/list-bg.5a909275.png";